import React, { useRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import config from "../../utils/config";
import { Slide as DialogSlide } from "../../components/dialog";
import { Warning } from "../../components/button";
import logoImg from "../../assets/images/64.png";
import { Div, LogoContainer, Logo, Title, ItemData } from "./style";

const Version = ({ children, theme, settings }) => {
  const versionRef = useRef();

  const [isLoadingClearCache, setIsLoadingClearCache] = useState(false);

  useEffect(() => {
    if (config.version < settings?.app_version) {
      versionRef.current.changeStatus();
    }
  }, [settings]);

  const update = () => {
    setIsLoadingClearCache(true);

    if (caches) {
      // Service worker cache should be cleared with caches.delete()
      caches.keys().then((names) => {
        for (const name of names) {
          caches.delete(name);
        }
      });
    }

    // delete browser cache and hard reload
    window.location.reload(true);
  };

  return (
    <>
      <DialogSlide
        ref={versionRef}
        className={`z-i-20000 status-p ${
          theme.isDarkTheme && "dark"
        } w-85 mx-auto`}
        onBackClose={false}
      >
        <Div className="p-2 py-3 text-right mb-2">
          <LogoContainer className="d-inline-block" theme={theme}>
            <Logo src={logoImg} />
          </LogoContainer>
          <Div className="d-inline-block vertical-align-middle mr-3">
            <Title className="f-15" theme={theme}>
              بروزرسانی جدید
            </Title>
            <Div className="mt-1">
              <ItemData className="f-12" theme={theme}>
                {config.description}
              </ItemData>
            </Div>
          </Div>
          <Div>
            <Warning
              containerClass="d-block mt-4"
              className="d-block"
              title="بروزرسانی"
              onClick={update}
              sizeSpinner={18}
              isLoading={isLoadingClearCache}
            />
          </Div>
        </Div>
      </DialogSlide>
      {children}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
    settings: state.settings?.settings,
  };
};

export default connect(mapStateToProps, false)(Version);
